import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $document = $(document);
const studyProgramBlockEl = $('.study-program-block');

$(function () {
    if (studyProgramBlockEl.length > 0) {
        studyProgramBlockEl.each(function () {
            studyProgramBlock($(this));
        });
    }
});

const studyProgramBlock = element => {
    const filter = {
        lang: element.data('lang'),
        heading: element.data('heading'),
        showFor: element.data('show-for'),
        page: 1,
        search: '',
        type: '',
        faculty: [],
        continent: [],
        state: [],
    };

    bindStudyProgram(element, filter);
    bindStudyProgramFilter(element, filter);

    const url = new URL(window.location);
    const sps = url.searchParams.get('sps');
    const t = url.searchParams.get('t');
    const fi = url.searchParams.get('fi');
    const ci = url.searchParams.get('ci');
    const si = url.searchParams.get('si');

    if (
        sps != null ||
        t != null ||
        fi != null ||
        ci != null ||
        si != null
    ) {
        filter.page = 1;
        filter.search = element.find("input[name='studyProgram-search']").val();
        filter.type = element.find("input[name='studyProgram-type']:checked").val();
        filter.faculty = element.find("select[name='studyProgram-faculty']").val();
        filter.continent = element.find("select[name='studyProgram-continent']").val();
        filter.state = element.find("select[name='studyProgram-state']").val();

        reRenderStudyProgram(element, filter);
    }
};

const reRenderStudyProgram = async (element, filter, append = false) => {
    const data = await getStudyProgram(filter);

    if (data != null) {
        if (append) {
            const blockContent = element.find('.study-program-block__content');
            const headdings = blockContent.find('.study-program-block__faculty-heading');
            const lastHeading = headdings.last();
            const dataHtml = $(data.html);
            const firstHeading = $(dataHtml[0]);

            blockContent.append(data.html);

            const newHeadings = blockContent.find('.study-program-block__faculty-heading');
            let lastElement = null;

            newHeadings.each(function () {
                const $thisEl = $(this);
                const thisHtml = $thisEl.html();
                if (thisHtml == lastHeading.html() && thisHtml == firstHeading.html()) {
                    lastElement = $thisEl;
                }
            });

            if (lastElement != null) {
                lastElement.remove();
            }
        } else {
            element.find('.study-program-block__content').html(data.html);
        }
    }
};

const bindStudyProgram = (element, filter) => {
    element.on('click', '.showMoreButton__item', function () {
        const $thisEl = $(this);
        filter.page = $thisEl.data('page');
        $thisEl.parent().remove();
        reRenderStudyProgram(element, filter, true);
    });
};

const bindStudyProgramFilter = async (element, filter) => {
    element.on(
        'input',
        "input[name='studyProgram-search']",
        debounce(
            function () {
                filter.page = 1;
                filter.search = element.find("input[name='studyProgram-search']").val();
                const url = new URL(window.location);
                filter.search != ''
                    ? url.searchParams.set('sps', filter.search)
                    : url.searchParams.delete('sps');

                window.history.replaceState({}, '', url);
                reRenderStudyProgram(element, filter);
            },
            false,
            400
        )
    );

    element.on('keyup', "input[name='studyProgram-search']", function (ev) {
        ev.key === 'Enter' && smoothscroll(element.find('.study-program-block__content'), 'header');
    });

    element.on('click', "input[name='studyProgram-type']", function () {
        const $thisEl = $(this);
        const url = new URL(window.location);
        if ($thisEl.val() == url.searchParams.get('t')) {
            $thisEl.prop('checked', false);
            filter.page = 1;
            filter.type = '';
            url.searchParams.delete('t');
            window.history.replaceState({}, '', url);
            reRenderStudyProgram(element, filter);
        }
    });

    element.on('change', "input[name='studyProgram-type']", function () {
        filter.page = 1;
        filter.type = $(this).val();
        const url = new URL(window.location);
        filter.type != '' ? url.searchParams.set('t', filter.type) : url.searchParams.delete('t');

        window.history.replaceState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('change', "select[name='studyProgram-faculty']", function () {
        filter.page = 1;
        filter.faculty = $(this).val();
        const url = new URL(window.location);
        filter.faculty != ''
            ? url.searchParams.set('fi', filter.faculty)
            : url.searchParams.delete('fi');

        window.history.replaceState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('change', "select[name='studyProgram-continent']", async function () {
        filter.page = 1;
        filter.continent = $(this).val();
        const url = new URL(window.location);
        filter.continent != ''
            ? url.searchParams.set('ci', filter.continent)
            : url.searchParams.delete('ci');

        window.history.replaceState({}, '', url);
        reRenderStudyProgram(element, filter);
        let data = await fetchStates(filter.continent, filter.lang);
        
        let stateOptions = '';
        for (var i = 0; i < data.length; i++) {
            stateOptions += '<option value="' + data[i].id + '">' + data[i].name + '</option>';
        }

        let selectState = element.find("select[name='studyProgram-state']");
        if (data.length == 0) {
            selectState.attr('disabled', 'disabled');
        } else {
            selectState.removeAttr('disabled');
        }
        selectState.empty();
        selectState.append(stateOptions);
    });

element.on('change', "select[name='studyProgram-state']", function () {
        filter.page = 1;
        filter.state = $(this).val();
        const url = new URL(window.location);
        filter.state != ''
            ? url.searchParams.set('si', filter.state)
            : url.searchParams.delete('si');

        window.history.replaceState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('click', "a[name='search-study-program-filter']", function () {
        filter.page = 1;
        const $thisEl = $(this);
        const parent = $thisEl.parent().parent();
        filter.search = parent.find("input[name='studyProgram-search']").val();
        filter.type = parent.find("input[name='studyProgram-type']:checked").val();
        filter.faculty = parent.find("select[name='studyProgram-faculty']").val();
        filter.continent = parent.find("select[name='studyProgram-continent']").val();
        filter.state = parent.find("select[name='studyProgram-state']").val();

        const url = new URL(window.location);
        url.searchParams.set('sb', '1');
        window.history.replaceState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('click', "a[name='remove-study-program-filter']", function () {
        filter.page = 1;
        filter.search = '';
        filter.type = '';
        filter.faculty = [];
        filter.continent = [];
        filter.state = [];

        const $thisEl = $(this);
        const parent = $thisEl.parent().parent();
        parent.find("input[name='studyProgram-search']").val('');
        parent.find("input[name='studyProgram-type']").prop('checked', false);
        const faculty = parent.find("select[name='studyProgram-faculty']");
        faculty.val([]).trigger('change.select2');
        const continent = parent.find("select[name='studyProgram-continent']");
        continent.val([]).trigger('change.select2');
        const state = parent.find("select[name='studyProgram-state']");
        state.val([]).trigger('change.select2');

        const url = new URL(window.location);
        url.searchParams.delete('sps');
        url.searchParams.delete('t');
        url.searchParams.delete('fi');
        url.searchParams.delete('ci');
        url.searchParams.delete('si');
        url.searchParams.delete('sb');
        window.history.replaceState({}, '', url);

        $('.study-program-block__content').html('');
    });
};

const getStudyProgram = async filter => {
    try {
        const response = await fetch(
            SITE_PARAMS.site_url + `/wp-json/mendelu/v1/study-program-block/html`,
            {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(filter),
            }
        );
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export const fetchStates = async (continents, lang) => {
    try {
        const response = await fetch(
            SITE_PARAMS.site_url + `/wp-json/mendelu/v1/other/state?cnt=` + continents.toString() + `&lang=` + lang,
            {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
            }
        );
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};